<div class="tcf">
  <header class="tcf-header">
    <h2>Assign role</h2>
  </header>

  <div class="tcf-body">
    <label class="field" *ngIf="availableRoles.length">
      <span class="field-label">Role</span>
      <select [(ngModel)]="selectedRoleId">
        <option [ngValue]="null" disabled>Select a role…</option>
        <option *ngFor="let r of availableRoles" [ngValue]="r.id">{{ r.name }}</option>
      </select>
    </label>
    <p class="tcf-subtitle" *ngIf="availableRoles.length === 0">All roles are already assigned.</p>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary"
            [disabled]="!selectedRoleId || submitting || availableRoles.length === 0" (click)="submit()">
      {{ submitting ? 'Assigning…' : 'Assign' }}
    </button>
  </footer>
</div>
